import React from 'react';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import { IZZZCharacter } from '../../../common/model/graphql-types';
import { Alert } from 'react-bootstrap';
import { ZZZElement } from './zzz-element';
import { ZZZRarity } from './zzz-rarity';
import { ZZZStyle } from './zzz-style';
import {
  faHandFist,
  faGavel,
  faFlask
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { RatingBox } from '../../../common/components/rating-box';

interface IProps {
  character: IZZZCharacter;
}

export const ZZZCharacterPopover: React.FC<IProps> = ({ character }) => {
  const image = character.smallImage
    ? getImage(character.smallImage.localFile.childImageSharp)
    : null;
  return (
    <div className="character-popover zzz">
      <div className="top zzz">
        <div className={`avatar zzz rarity-${character.rarity}`}>
          {image && (
            <GatsbyImage
              className="disable-transition"
              image={image}
              alt={`${character.name}`}
            />
          )}
        </div>
        <p className="name">
          <span className="emp-name">{character.name}</span>
        </p>
        <div className="type-class">
          <ZZZRarity rarity={character.rarity} />
          <ZZZElement element={character.element} character={character.slug} />
          <ZZZStyle style={character.style} />
        </div>
      </div>
      {character.ratings.shiyu != 1 ? (
        <>
          <p className="hsr-role">
            This character belongs to the{' '}
            {(character.tierListCategory === 'DPS' ||
              character.tierListCategory === 'Anomaly') && (
              <span className="role dps">
                <FontAwesomeIcon icon={faHandFist} width="12" /> DPS
              </span>
            )}
            {character.tierListCategory === 'Stun' && (
              <span className="role support">
                <FontAwesomeIcon icon={faGavel} width="12" /> Stun
              </span>
            )}
            {character.tierListCategory === 'Support' && (
              <span className="role sustain">
                <FontAwesomeIcon icon={faFlask} width="12" /> Support
              </span>
            )}{' '}
            role and the ratings rate their performance at this role only.
          </p>
          <div className="bottom full">
            <RatingBox
              game="hsr"
              rating={character.ratings.shiyu}
              ratingName="Endgame Content"
            />
          </div>
        </>
      ) : (
        <Alert variant="primary">
          <p>
            This character ratings aren't available yet and they will be added
            once the characters is released.
          </p>
        </Alert>
      )}
    </div>
  );
};
